function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import chroma from "chroma-js";
import luminanceScales from "../utils/luminanceScales";
var shmonsole = console;
export function createColorSwatch(seedColor, themeName, nominalContrast, adjustedColor) {
    if (chroma.valid(seedColor)) {
        var validAdjustedColor = chroma.valid(adjustedColor);
        var generatedColor = chroma(seedColor).luminance(getLuminance(themeName, nominalContrast)).css();
        return {
            get nominalContrast () {
                return nominalContrast;
            },
            get generatedColor () {
                return generatedColor;
            },
            adjustedColor: validAdjustedColor ? adjustedColor : undefined,
            useAdjusted: validAdjustedColor
        };
    }
    shmonsole.error("[createColorSwatch]: \"".concat(seedColor, "\" is not a valid seedColor. \nProvide in CSS color value format"));
    return undefined;
}
export default createColorSwatch;
export function finalizeColorSwatch(param) {
    var generatedColor = param.generatedColor, adjustedColor = param.adjustedColor, exactColor = param.exactColor, useExact = param.useExact, useAdjusted = param.useAdjusted, nominalContrast = param.nominalContrast;
    return _defineProperty({}, nominalContrast, useExact && exactColor || useAdjusted && adjustedColor || generatedColor);
}
export function finalizeColorSwatchValue(swatch) {
    return Object.values(finalizeColorSwatch(swatch))[0];
}
function getLuminanceScale(themeName) {
    switch(themeName){
        case 'default':
            return luminanceScales.default;
        case 'dark':
            return luminanceScales.dark;
        default:
            shmonsole.error("[createColorSwatch] themeName \"".concat(themeName, "\" is not valid, \"default\" was used."));
            return luminanceScales.default;
    }
}
function getLuminance(themeName, _nominalContrast) {
    var nominalContrast = "".concat(_nominalContrast);
    var luminanceScale = getLuminanceScale(themeName);
    var hasNominalContrast = Object.keys(luminanceScale).includes(nominalContrast);
    return hasNominalContrast ? luminanceScale[nominalContrast] : luminanceScale.max;
}
